(() => {
  if (window.guardenProofReady) return;
  window.guardenProofReady = true;
  const states = new WeakMap();
  function openProof(trigger) {
    const dialog = document.querySelector('[data-guarden-proof]');
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    if (dialog.open) return true;
    states.set(dialog, { trigger, overflow: document.body.style.overflow });
    dialog.showModal();
    document.body.style.overflow = 'hidden';
    dialog.querySelector('[data-proof-close]').focus();
    return true;
  }
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest('[data-guarden-proof-open]');
    if (trigger) {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (openProof(trigger)) event.preventDefault();
      return;
    }
    const dialog = event.target.closest('[data-guarden-proof]');
    if (!dialog) return;
    if (event.target.closest('[data-proof-close]')) { dialog.close(); return; }
    if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
    const play = event.target.closest('[data-proof-play]');
    if (play) {
      const media = play.closest('[data-proof-video]');
      if (!media.querySelector('video')) media.append(media.querySelector('template').content.cloneNode(true));
      play.hidden = true;
      const video = media.querySelector('video');
      video.focus();
      const promise = video.play();
      if (promise) promise.catch(() => {});
    }
    const report = event.target.closest('[data-proof-report]');
    if (report) {
      const panel = document.getElementById(report.getAttribute('aria-controls'));
      const expanded = report.getAttribute('aria-expanded') === 'true';
      report.setAttribute('aria-expanded', String(!expanded));
      panel.hidden = expanded;
      const frame = panel.querySelector('[data-proof-frame]');
      if (!expanded && !frame.hasAttribute('src')) frame.src = report.dataset.proofReport;
    }
  });
  document.addEventListener('close', (event) => {
    const dialog = event.target;
    if (!(dialog instanceof Element) || !dialog.matches('[data-guarden-proof]')) return;
    dialog.querySelectorAll('video').forEach(video => video.pause());
    const state = states.get(dialog);
    if (state) {
      document.body.style.overflow = state.overflow;
      if (state.trigger && state.trigger.isConnected) state.trigger.focus({ preventScroll: true });
      states.delete(dialog);
    }
  }, true);
  document.addEventListener('shopify:section:select', (event) => {
    if (event.target.querySelector('[data-guarden-proof]')) openProof(null);
  });
  document.addEventListener('shopify:block:select', (event) => {
    if (event.target.closest('[data-guarden-proof]')) { openProof(null); event.target.scrollIntoView({ block: 'nearest' }); }
  });
})();
